module.exports = __webpack_public_path__ + "static/dotnet-60ec49659c073c36c311b80f4e76f6db.mp4";